import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import MainImage from './MainImage';
import SwiperPart from './SwiperPart';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import chipDataTransform from 'chipDataTransform';

const Layout = ({ content }) => {

    const [ currentIndex, setCurrentIndex ] = useState(0);
    const [ action, setAction ] = useState('next');

    useEffect(() => {
        if (window.screen.width <= 750) {
            window.location.href = 'https://ishare.ifeng.com/c/s/8FlVBMBSHlA';
        }
    }, []);

    return (
        <div className={styles.layout}>
            <Chip id={260214} type="struct" name="ImageList" title="数据列表" groupName="数据列表" key="ImageList" content={content.ImageList}>
                <MainImage currentIndex={currentIndex} action={action} setCurrentIndex={setCurrentIndex} setAction={setAction} />
            </Chip>

            <SwiperPart currentIndex={currentIndex} setCurrentIndex={setCurrentIndex} setAction={setAction} content={content.ImageList} />
            <ChipEdit transform={chipDataTransform} />
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
